module.exports = __webpack_public_path__ + "packs/media/images/palestraBoulder3-c6b633e54f7f37ac0e10bcab95ec557f.jpg";